import { render } from "./pricing-update.vue?vue&type=template&id=5bcd0c1a"
import script from "./pricing-update.vue?vue&type=script&lang=js"
export * from "./pricing-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__